import { Grid, Tabs, Tab } from '@material-ui/core'

export default function TabsMenu({
  selectedTab,
  kinds,
  handleChange
}) {
  return(
    <Grid item sm={12} xs={12}>
      <Tabs
        value={selectedTab}
        indicatorColor='primary'
      >
        {
          kinds.map(tab =>
            <Tab
              label={tab.name}
              key={tab.id}
              onClick={() => handleChange(tab.id)}
            />
          )
        }
      </Tabs>
    </Grid>
  )
}